import ExtrachargeCategoryIndexVue from "@/views/extracharge-category/ExtraChargeCategoryIndex.vue";

const extrachargeCategory = [
  {
    path: "/extracharge-category",
    name: "extracharge-category",
    component: ExtrachargeCategoryIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
];

export default extrachargeCategory;
